import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useParams } from 'react-router-dom';
import {
  getIsUserLoggedInSelector,
  getUserAccessTokenSelector,
} from '@xarvio/frontend-core-state/lib/auth/selectors';
import { useUrlQuery } from '@xarvio/frontend-core-components/hooks/useUrlQuery';
import {
  getReturnUrl,
  appendHandoffToken,
} from '@xarvio/frontend-core-platform/lib/returnUrl';

export interface GuardProps {
  children: React.ReactElement;
  redirectPath?: string;
}

export const RequireAuth: React.FC<GuardProps> = ({
  children,
  redirectPath,
}) => {
  const isLoggedIn = useSelector(getIsUserLoggedInSelector);
  const { country, locale } = useParams<{ country: string; locale: string }>();

  if (!isLoggedIn) {
    const path = redirectPath || `/${country}/${locale}/login`;
    return <Navigate to={path} replace />;
  }

  return children;
};

export const RequireGuest: React.FC<GuardProps> = ({
  children,
  redirectPath,
}) => {
  const isLoggedIn = useSelector(getIsUserLoggedInSelector);
  const userAccessToken = useSelector(getUserAccessTokenSelector);
  const { country, locale } = useParams<{ country: string; locale: string }>();
  const urlSearchParams = useUrlQuery();
  const returnUrl = isLoggedIn ? getReturnUrl(urlSearchParams) : null;

  useEffect(() => {
    if (returnUrl) {
      window.location.href = appendHandoffToken(returnUrl, userAccessToken);
    }
  }, [returnUrl, userAccessToken]);

  if (isLoggedIn) {
    if (returnUrl) {
      return null;
    }

    const path = redirectPath || `/${country}/${locale}/`;
    return <Navigate to={path} replace />;
  }

  return children;
};
